import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import {
  CreateExperimentDraftMutation,
  CreateExperimentDraftMutationVariables
} from './__generated__/CreateExperimentDraftMutation';
import { CREATE_EXPERIMENT_DRAFT_MUTATION } from './createExperimentDraft.mutation';

interface Props {
  onError: (errors: string[]) => void;
  onCompleted?: (data?: CreateExperimentDraftMutation) => void;
}

export function useCreateExperimentDraftMutation({
  onError,
  onCompleted
}: Props): [(variables: CreateExperimentDraftMutationVariables) => void, { loading: boolean }] {
  const [createExperimentDraft, { loading }] = useMutation<
    CreateExperimentDraftMutation,
    CreateExperimentDraftMutationVariables
  >(CREATE_EXPERIMENT_DRAFT_MUTATION, {
    client: kmsClient,
    onError: (error) => onError([error.message]),
    onCompleted: (data) => {
      if (data.createExperimentDraft?.experiment) {
        if (onCompleted) onCompleted(data);
      }

      if (data.createExperimentDraft?.errors) {
        onError(data.createExperimentDraft?.errors);
      }
    }
  });

  return [(variables) => createExperimentDraft({ variables }), { loading }];
}
